import React from 'react';
import jwt from 'jsonwebtoken';

function getUserRoles(){
    const token = localStorage.getItem('userToken');
    const decoded = jwt.decode(token, {complete: true});
    const roles = decoded.payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    return roles;
}

function logout() {
    localStorage.clear();
    window.location.reload();
}

export {logout, getUserRoles};



// WEBPACK FOOTER //
// ./engine/userManagements.js